import { StyleSheet } from 'react-native'
export { default as OSIcon } from '@expo/vector-icons/MaterialIcons'
export { default as MarkerIcon } from '@expo/vector-icons/Foundation'

export const styles = StyleSheet.create({
  modalContainer: {
    flexShrink: 1,
    minHeight: 0,
    overflow: 'hidden'
  },
  container: {
    flexShrink: 1,
    minHeight: 0
  },
  content: {
    flexShrink: 1,
    minHeight: 0
  },
  actions: {
    flexShrink: 0,
    flexWrap: 'wrap'
  },
  title: {
    fontWeight: '700',
    marginBottom: 8
  }
})
